import styled from "styled-components";

export const StyledTagContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	column-gap: 1.2rem;
	row-gap: 1.2rem;

	button {
		margin: 0 0 0 0.5rem;
	}
`;
